/**
 * @generated SignedSource<<a7424e32c37803d50089b16bb676f04a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventsFragment$data = {
  readonly events?: {
    readonly __id: string;
    readonly count: number | null;
    readonly edges: ReadonlyArray<{
      readonly __id: string;
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"eventInlineFragment">;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "eventsFragment";
};
export type eventsFragment$key = {
  readonly " $data"?: eventsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "events"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v19 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "questionResponse",
    "storageKey": null
  }
],
v20 = {
  "kind": "InlineDataFragmentSpread",
  "name": "userProfileNameInlineFragment",
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/)
  ]
},
v21 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "filter"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "ordering"
    },
    {
      "kind": "RootArgument",
      "name": "skip"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./eventsRefetchableQuery.graphql')
    }
  },
  "name": "eventsFragment",
  "selections": [
    {
      "condition": "skip",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "events",
          "args": [
            {
              "kind": "Variable",
              "name": "filter",
              "variableName": "filter"
            },
            {
              "kind": "Variable",
              "name": "ordering",
              "variableName": "ordering"
            }
          ],
          "concreteType": "EventConnection",
          "kind": "LinkedField",
          "name": "__connection_events_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Event",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "eventInlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v5/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "location",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "beginsAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "endsAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recurring",
                          "storageKey": null
                        },
                        (v6/*: any*/),
                        (v7/*: any*/),
                        (v8/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "createdBy",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "comment",
                          "storageKey": null
                        },
                        (v9/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "icalendar",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recurrenceID",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "originalStartTime",
                          "storageKey": null
                        },
                        (v10/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventGuest",
                          "kind": "LinkedField",
                          "name": "eventGuests",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "eventGuestInlineFragment",
                              "selections": [
                                (v1/*: any*/),
                                (v9/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "assessmentStatus",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Contact",
                                  "kind": "LinkedField",
                                  "name": "contact",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "contactBaseInlineFragment",
                                      "selections": [
                                        (v1/*: any*/),
                                        (v11/*: any*/),
                                        (v12/*: any*/),
                                        (v8/*: any*/),
                                        (v3/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "unmindUserId",
                                          "storageKey": null
                                        },
                                        {
                                          "kind": "InlineDataFragmentSpread",
                                          "name": "contactSessionLimitsRemainingInlineFragment",
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "SessionLimitPayload",
                                              "kind": "LinkedField",
                                              "name": "sessionLimits",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "kind": "ScalarField",
                                                  "name": "sessionLimitType",
                                                  "storageKey": null
                                                },
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "kind": "ScalarField",
                                                  "name": "amountRemaining",
                                                  "storageKey": null
                                                },
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "kind": "ScalarField",
                                                  "name": "expiryDate",
                                                  "storageKey": null
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "SalesOrder",
                                  "kind": "LinkedField",
                                  "name": "salesOrders",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "salesOrderBaseInlineFragment",
                                      "selections": [
                                        (v1/*: any*/),
                                        (v13/*: any*/),
                                        (v4/*: any*/),
                                        (v3/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "customerEmail",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "customerFirstName",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "customerLastName",
                                          "storageKey": null
                                        },
                                        (v9/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "totalAmount",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "grandAmount",
                                          "storageKey": null
                                        },
                                        (v14/*: any*/),
                                        (v15/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "eventRecurringId",
                                          "storageKey": null
                                        },
                                        (v10/*: any*/),
                                        (v16/*: any*/),
                                        (v17/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "Payment",
                                          "kind": "LinkedField",
                                          "name": "payment",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "InlineDataFragmentSpread",
                                              "name": "paymentBaseInlineFragment",
                                              "selections": [
                                                (v1/*: any*/),
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "kind": "ScalarField",
                                                  "name": "paidAt",
                                                  "storageKey": null
                                                },
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "kind": "ScalarField",
                                                  "name": "amount",
                                                  "storageKey": null
                                                },
                                                (v14/*: any*/),
                                                (v4/*: any*/),
                                                (v10/*: any*/),
                                                (v16/*: any*/),
                                                (v17/*: any*/)
                                              ]
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ]
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "SalesOrderItem",
                                      "kind": "LinkedField",
                                      "name": "salesOrderItems",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "InlineDataFragmentSpread",
                                          "name": "salesOrderItemInlineFragment",
                                          "selections": [
                                            (v1/*: any*/),
                                            (v2/*: any*/),
                                            (v5/*: any*/),
                                            {
                                              "alias": null,
                                              "args": null,
                                              "kind": "ScalarField",
                                              "name": "quantity",
                                              "storageKey": null
                                            },
                                            (v18/*: any*/),
                                            {
                                              "alias": null,
                                              "args": null,
                                              "kind": "ScalarField",
                                              "name": "discount",
                                              "storageKey": null
                                            },
                                            (v14/*: any*/),
                                            (v15/*: any*/),
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "Product",
                                              "kind": "LinkedField",
                                              "name": "product",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "kind": "InlineDataFragmentSpread",
                                                  "name": "productFragment",
                                                  "selections": [
                                                    (v1/*: any*/),
                                                    (v13/*: any*/),
                                                    (v4/*: any*/),
                                                    (v2/*: any*/),
                                                    (v5/*: any*/),
                                                    (v7/*: any*/),
                                                    (v18/*: any*/),
                                                    (v14/*: any*/),
                                                    (v15/*: any*/),
                                                    (v10/*: any*/)
                                                  ]
                                                }
                                              ],
                                              "storageKey": null
                                            }
                                          ]
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "EventGuestAssessmentResponses",
                                  "kind": "LinkedField",
                                  "name": "eventGuestAssessmentResponses",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "InlineDataFragmentSpread",
                                      "name": "eventGuestAssessmentResponsesInlineFragment",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "EventGuestAssessmentResponse",
                                          "kind": "LinkedField",
                                          "name": "GAD",
                                          "plural": true,
                                          "selections": (v19/*: any*/),
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "EventGuestAssessmentResponse",
                                          "kind": "LinkedField",
                                          "name": "PHQ",
                                          "plural": true,
                                          "selections": (v19/*: any*/),
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "EventGuestAssessmentResponse",
                                          "kind": "LinkedField",
                                          "name": "Workplace",
                                          "plural": true,
                                          "selections": (v19/*: any*/),
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "submittedAt",
                                          "storageKey": null
                                        }
                                      ]
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ]
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "UserProfile",
                          "kind": "LinkedField",
                          "name": "userProfile",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "userProfileBaseFragment"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "userProfileNameFragment"
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "userProfileBaseInlineFragment",
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "email",
                                  "storageKey": null
                                },
                                (v13/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "countryId",
                                  "storageKey": null
                                },
                                (v6/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "photoUrls",
                                  "storageKey": null
                                }
                              ]
                            },
                            (v20/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "UserProfile",
                          "kind": "LinkedField",
                          "name": "createdByUserProfile",
                          "plural": false,
                          "selections": [
                            (v20/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "zoomMeetingDetails",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sessionType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "googleMeetDetails",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "completedDatetime",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "cancellationReasonType",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "practitionerConfirmationDatetime",
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                },
                (v21/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v21/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "f1864a860bc4e4789e612fdc3fb0ebd2";

export default node;
